module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dialog', {
    ref: "inviteOpponent",
    staticClass: "mdl-dialog"
  }, [_c('h6', {
    staticClass: "mdl-dialog__title"
  }, [_vm._v("Invite Player")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-dialog__content"
  }, [_c('div', {
    staticClass: "invite-url-container"
  }, [_c('mdl-textfield', {
    ref: "inviteUrl",
    attrs: {
      "value": _vm.invitationUrl,
      "readonly": ""
    }
  }), _vm._v(" "), _c('mdl-tooltip', {
    attrs: {
      "target": "copy_invite"
    }
  }, [_vm._v("Copy Invite URL")]), _vm._v(" "), _c('mdl-button', {
    attrs: {
      "id": "copy_invite",
      "icon": "content_copy"
    },
    nativeOn: {
      "click": function($event) {
        _vm.copyInvite($event)
      }
    }
  })], 1), _vm._v(" "), _c('mdl-progress', {
    attrs: {
      "indeterminate": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mdl-dialog__actions"
  }, [_c('mdl-button', {
    nativeOn: {
      "click": function($event) {
        _vm.cancel($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44ea09be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/game/InviteOpponentDialog.vue
// module id = 419
// module chunks = 1